import { createAction } from "@ngrx/store";

export const CloseSidenavAction = createAction('[Shared] close sidenav content');

